var React = require('react');

function Bullet (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"4","cy":"4","r":"4","fill":"currentColor"}));
}

Bullet.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none"};

module.exports = Bullet;

Bullet.default = Bullet;
